import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "mapWrapper",
  ref: "mapWrapper"
}
const _hoisted_2 = { id: "map" }
const _hoisted_3 = {
  key: 0,
  class: "weatherWarningBanner"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "popupContainer",
  style: {"position":"absolute","left":"-9999px","top":"-9999px","visibility":"hidden"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeviceSearch = _resolveComponent("DeviceSearch")!
  const _component_MLPassagesPanel = _resolveComponent("MLPassagesPanel")!
  const _component_DownloadSessionPanel = _resolveComponent("DownloadSessionPanel")!
  const _component_DeviceInfo = _resolveComponent("DeviceInfo")!
  const _component_MarkerActions = _resolveComponent("MarkerActions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DeviceSearch)
    ]),
    (_ctx.activeWeatherWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.activeWeatherWarningIconUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.activeWeatherWarningIconUrl,
                alt: "Weather warning icon",
                class: "weatherWarningIcon"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.activeWeatherWarning), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_MLPassagesPanel, { visible: _ctx.showMLPanel }, null, 8, ["visible"]),
    _createVNode(_component_DownloadSessionPanel),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_DeviceInfo, { ref: "deviceInfoRef" }, null, 512),
      _createVNode(_component_MarkerActions, { ref: "markerActionsRef" }, null, 512)
    ])
  ], 512))
}